import { SignUpPage } from "@/components/pages/SignUpPage"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { authClient } from "@/lib/auth-client"
import { defaultMeta, noIndex } from "@/lib/seo"

export const Route = createFileRoute(`/sign-up`)({
  head: () =>
    defaultMeta({
      title: `Create an Account`,
      description: `Create a ChicTravel account to start planning collaborative travel itineraries.`,
      path: `/sign-up`,
      robots: noIndex,
    }),
  component: SignUpPage,
  ssr: false, // beforeLoad runs client-side only, so authClient.getSession works
  beforeLoad: async () => {
    // Already signed in? No reason to show the sign-up form — honor an explicit
    // ?redirect= (e.g. an interrupted guide copy), else send them to their trips.
    const { data } = await authClient.getSession()
    if (!data) return
    const target = new URLSearchParams(window.location.search).get(`redirect`)
    if (target) throw redirect({ href: target })
    throw redirect({ to: `/dashboard` })
  },
})
